import { render, staticRenderFns } from "./VSelectPublic.vue?vue&type=template&id=485df438"
import script from "./VSelectPublic.vue?vue&type=script&lang=js"
export * from "./VSelectPublic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports